import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Webinars from "../components/Webinars";
import EnglishCourses from "../components/EnglishCourses";
import CTABand from "../components/CTABand";
import ApplicationDialog from "../components/ApplicationDialog";
import FloatingContact from "../components/FloatingContact";
import { useLang } from "../i18n/LangContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EnglishTestPage = () => {
  const { lang } = useLang();
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState(1200);
  const [formOpen, setFormOpen] = useState(false);
  const openForm = () => setFormOpen(true);

  // Receive postMessages from the iframe quiz
  useEffect(() => {
    const handler = async (e) => {
      if (!e.data || typeof e.data !== "object") return;

      if (e.data.type === "studygri-english-resize" && typeof e.data.height === "number") {
        setIframeHeight((prev) => {
          const next = Math.max(900, e.data.height + 24);
          return Math.abs(next - prev) < 16 ? prev : next;
        });
      }

      if (e.data.type === "studygri-english-submit") {
        const { name, email, phone, consent, level, score, total } = e.data;
        try {
          await axios.post(`${API}/leads`, {
            name,
            phone: phone || "",
            email,
            country: "",
            program: `English Level Test · ${level || "—"}`,
            message: `English level test result: ${level || "?"} (${score}/${total}). Consent: ${consent ? "yes" : "no"}`,
            lang,
            source: "english-test",
          });
          iframeRef.current?.contentWindow?.postMessage(
            { type: "studygri-english-submit-success" },
            "*"
          );
        } catch (err) {
          iframeRef.current?.contentWindow?.postMessage(
            { type: "studygri-english-submit-error" },
            "*"
          );
        }
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [lang]);

  // Sync language to iframe
  useEffect(() => {
    const send = () => {
      try {
        iframeRef.current?.contentWindow?.postMessage(
          { type: "studygri-english-set-lang", lang },
          "*"
        );
      } catch (e) {
        /* noop */
      }
    };
    const t1 = setTimeout(send, 800);
    return () => clearTimeout(t1);
  }, [lang]);

  return (
    <div className="min-h-screen" style={{ background: "#F8F4EE" }} data-testid="english-test-page">
      <Header onOpenForm={openForm} />
      <main className="pt-28 md:pt-36">
        <iframe
          ref={iframeRef}
          src="/english-level-test.html"
          title="STUDYGRI English Level Test"
          style={{ width: "100%", height: `${iframeHeight}px`, border: 0, display: "block" }}
          data-testid="english-test-iframe"
        />
        <EnglishCourses onBook={openForm} />
        <Webinars />
        <CTABand onOpenForm={openForm} />
      </main>
      <Footer />
      <FloatingContact onOpenForm={openForm} />
      <ApplicationDialog open={formOpen} onOpenChange={setFormOpen} />
    </div>
  );
};

export default EnglishTestPage;
